export default __webpack_public_path__ + "static/media/_ic_trax_act.5a3e0805.svg";